import React from 'react';
import { useSelector } from 'react-redux';

import ChecklistTableAdmin from '../../Components/ChecklistTables/ChecklistTableAdmin';
import ChecklistTableTeacher from '../../Components/ChecklistTables/ChecklistTableTeacher';
import { getUserType } from '../../redux/slices/userSlice';

interface Props {
  mail: string;
}

export default function CheckListTable({ mail }: Props) {
  const userTypeSelector = useSelector(getUserType);

  if (userTypeSelector === 'Teacher') {
    return <ChecklistTableTeacher mail={mail} />;
  } else {
    return <ChecklistTableAdmin />;
  }
}
